import { render, staticRenderFns } from "./PosTransaction.vue?vue&type=template&id=9916fbea&"
import script from "./PosTransaction.vue?vue&type=script&lang=js&"
export * from "./PosTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports